<div class="dynamic-select">
    <mat-form-field appearance="outline" *ngIf="isEditMode()">
      <mat-label>{{data.columnName}}</mat-label>
      <mat-select (selectionChange)="updateSelection($event.value)" [(ngModel)]="selectedOption">
        <mat-option *ngFor="let op of foreignKeyOptions" [value]="op" >
          {{op[selectOptionValue]}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    
    <mat-label *ngIf="data.value != null && !isEditMode()" style="font-size: 10px;">{{data.columnName}}</mat-label>
    <mat-chip-list *ngIf="!isEditMode()" class="chip-edit" >
      <mat-chip *ngIf="data.value != null" class="chip-edit" color="primary" selected (click)="switchEditingMode()"> 
        {{getSelectedValue()}}
      </mat-chip>
      <mat-chip (click)="switchEditingMode()" *ngIf="!data.value"> 
        {{data.columnName}}: 
      </mat-chip>
    </mat-chip-list>
    
    
    <i class="fas fa-solid fa-angle-up icon" *ngIf="isEditMode()" (click)="switchEditingMode()"></i>
  </div>